import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { AmountServer } from "../../../server";

const server = AmountServer.InternationalRemittanceCountriesList;

const DEFAULT_OPERATION_DATA = {
    Code: '',
    CurrencyCode: '',
    NameCn: '',
    SlippageRate: 0,
    Status: 1,
}

type OperateModeType = 'create' | 'update'

export const Operation = forwardRef((props: any, ref: any) => {
    const { onSuccess } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('create');

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
                ...(mode === 'update' ? val : {})
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(mode === 'create' ? server.create : server.update, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(mode === 'create' ? '新增成功' : '更新成功');
            changeVisible(false);
            onSuccess?.();
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return [
            {
                title: "国家中文名称",
                field: "NameCn",
                type: "input",
                placeholder: "请输入国家中文名称",
                required: true,
            },
            {
                title: "国家代码",
                field: "Code",
                type: "input",
                placeholder: "请输入国家代码",
                required: true,
            },
            {
                title: "货币代码",
                field: "CurrencyCode",
                type: "input",
                placeholder: "请输入货币代码",
                required: true,
            },
            {
                title: "滑点比例",
                field: "SlippageRate",
                type: "inputNumber",
                placeholder: "请输入滑点比例",
                required: true,
            },
            {
                title: "排序",
                field: "Sort",
                type: "inputNumber",
                placeholder: "请输入排序",
                required: true,
            },
            {
                title: "状态",
                field: "Status",
                type: "select",
                placeholder: "请选择状态",
                required: true,
                options: [
                    { name: "可用", id: 1 },
                    { name: "禁用", id: 2 },
                ],
            },
        ];
    }, [formData, mode]);

    return (
        <div>
            <Modal
                title={mode === 'create' ? '新增国家' : '编辑国家'}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    run(formData);
                }}
            >
                <EditForm
                    componentId="country-operation"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 8 },
                        wrapperCol: { span: 16 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                />
            </Modal>
        </div>
    );
})
